import { PageHeader } from "@/components/PageHeader";
import { HeartPulse } from "lucide-react";

interface PlatformHealthPlaceholderProps {
  title: string;
  subtitle: string;
}

export function PlatformHealthPlaceholder({ title, subtitle }: PlatformHealthPlaceholderProps) {
  return (
    <div className="px-4 py-0">
      <PageHeader title={title} subtitle={subtitle} />
      <div className="rounded-lg border border-dashed border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-800 p-12 text-center">
        <HeartPulse className="mx-auto h-8 w-8 text-gray-400 dark:text-zinc-500" />
        <p className="mt-4 text-sm font-medium text-gray-900 dark:text-white">Nothing here yet</p>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          This page has not been built out yet.
        </p>
      </div>
    </div>
  );
}
